import {
  getObjects,
  createObject,
  getSingleObject,
  getObjectTypes,
  updateObject,
  getInfrastructures,
  getParkingOptions,
  deleteMediaFile,
  getObjectCalculations,
  getConstructionProgress,
  createConstructionProgress,
  createObjectCalculationItem,
  updateObjectCalculationItem,
  getObjectPriceHistory,
  getObjectDiscountHistory,
  getPaymentTypes,
  getOnePaymentType,
  getObjectContractsReport,
  excelUpload,
  getReportsTable,
  getOverallTable,
  getSoldFlat,
  getNotSoldFlat,
  getAllClientsTable,
  getAllClientsByIcome,
  lastOvrallTable,
  getRelatedPerson,
} from '@/api/objects'

export default {
  FETCH_OVERALL_LIST_TABLE({ commit }, params) {
    return new Promise((resolve, reject) => {
      lastOvrallTable(params)
        .then(response => {
          commit('SET_OVERALL_LIST_TABLE', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_ALL_CLIENTS_BY_INCOME({ commit }, params) {
    return new Promise((resolve, reject) => {
      getAllClientsByIcome(params)
        .then(response => {
          commit('SET_ALL_CLIENTS_BY_INCOME', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_ALL_CLIENTS_TABLE({ commit }, params) {
    return new Promise((resolve, reject) => {
      getAllClientsTable(params)
        .then(response => {
          commit('SET_ALL_CLIENTS_TABLE', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_NOT_SOLD_FLAT({ commit }, params) {
    return new Promise((resolve, reject) => {
      getNotSoldFlat(params)
        .then(response => {
          commit('SET_NOT_SOLD_FLAT', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_SOLD_FLAT({ commit }, params) {
    return new Promise((resolve, reject) => {
      getSoldFlat(params)
        .then(response => {
          commit('SET_SOLD_FLAT', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_OVERALL_TABLE({ commit }, params) {
    return new Promise((resolve, reject) => {
      getOverallTable(params)
        .then(response => {
          commit('SET_OVERALL_TABLE', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_OBJECTS({ commit }, params) {
    return new Promise((resolve, reject) => {
      getObjects(params)
        .then(response => {
          commit('SET_OBJECTS', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  EXCEL_UPLOAD(_, data) {
    return excelUpload(data)
  },
  ADD_OBJECT(a, data) {
    return createObject(data)
  },
  DELETE_MEDIA_FILE(a, data) {
    return deleteMediaFile(data)
  },
  EDIT_OBJECT(a, data) {
    return updateObject(data)
  },
  FETCH_ONE_OBJECT({ commit }, object_id) {
    return new Promise((resolve, reject) => {
      getSingleObject(object_id)
        .then(response => {
          commit('SET_ONE_OBJECT', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_OBJECT_TYPES({ commit }, params) {
    return new Promise((resolve, reject) => {
      getObjectTypes(params)
        .then(response => {
          commit('SET_OBJECT_TYPES', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_OBJECT_INFRASTURCTURES({ commit }) {
    return new Promise((resolve, reject) => {
      getInfrastructures()
        .then(response => {
          commit('SET_OBJECT_INFRASTURCTURES', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_PARKING_OPTIONS({ commit }) {
    return new Promise((resolve, reject) => {
      getParkingOptions()
        .then(response => {
          commit('SET_PARKING_OPTIONS', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_CONSTRUCTION_PROGRESS({ commit }, data) {
    return new Promise((resolve, reject) => {
      getConstructionProgress(data)
        .then(response => {
          commit('SET_CONSTRUCTION_PROGRESS', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  ADD_CONSTRUCTION_PROGRESS(_, data) {
    return createConstructionProgress(data)
  },
  FETCH_OBJECT_CALCULATIONS({ commit }, data) {
    return new Promise((resolve, reject) => {
      getObjectCalculations(data)
        .then(response => {
          commit('SET_OBJECT_CALCULATIONS', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  ADD_OBJECT_DISCOUNT_OPTION(_, data) {
    return createObjectCalculationItem(data)
  },
  EDIT_OBJECT_DISCOUNT_OPTION(_, data) {
    return updateObjectCalculationItem(data)
  },
  FETCH_PRICE_HISTORY({ commit }, data) {
    return new Promise((resolve, reject) => {
      getObjectPriceHistory(data)
        .then(response => {
          commit('SET_OBJECT_PRICE_HISTORY', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_DISCOUNT_HISTORY({ commit }, data) {
    return new Promise((resolve, reject) => {
      getObjectDiscountHistory(data)
        .then(response => {
          commit('SET_OBJECT_DISCOUNT_HISTORY', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_PAYMENT_TYPES({ commit }, data) {
    return new Promise((resolve, reject) => {
      getPaymentTypes(data)
        .then(response => {
          commit('SET_PAYMENT_TYPES', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_ONE_PAYMENT_TYPE({ commit }, data) {
    return new Promise((resolve, reject) => {
      getOnePaymentType(data)
        .then(response => {
          commit('SET_ONE_PAYMENT_TYPE', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  FETCH_OBJECT_CONTRACTS_REPORT(_, data) {
    return getObjectContractsReport(data)
  },

  FETCH_REPORTS_TABLE({ commit }, params) {
    return new Promise((resolve, reject) => {
      getReportsTable(params)
        .then(response => {
          commit('SET_REPORTS', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  FETCH_RELATED_PERSON({ commit }, params) {
    return new Promise((resolve, reject) => {
      getRelatedPerson(params)
        .then(response => {
          commit('SET_RELATED_PERSON', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
